import {
  AbstractDefaultPropsModel,
  MetaImageSizeOptionsType,
  TranslationColumnValueModel,
  UploadModel,
} from '@ckmk/angular';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';

export class PostModel extends AbstractDefaultPropsModel {
  /**
   * The post id
   * @protected
   */
  public get id(): string | undefined {
    return this.get('id');
  }
  public set id(id: string | undefined) {
    this.set('id', id);
  }

  /**
   * The post category
   * @protected
   */
  public get category(): PostCategoryModel | undefined {
    return this.get('category');
  }
  public set category(category: any) {
    this.setInstance('category', PostCategoryModel, category);
  }

  /**
   * The post cover
   * @protected
   */
  public get cover(): UploadModel | undefined {
    return this.get('cover');
  }
  public set cover(cover: any) {
    this.setInstance('cover', UploadModel, cover);
  }

  /**
   * The post picture
   * @protected
   */
  public get picture(): UploadModel | undefined {
    return this.get('picture');
  }
  public set picture(picture: any) {
    this.setInstance('picture', UploadModel, picture);
  }

  /**
   * The post pictures
   * @protected
   */
  public get pictures(): UploadModel[] {
    return this.get('pictures', []);
  }
  public set pictures(pictures: any[]) {
    this.set(
      'pictures',
      (pictures || []).map((pic: any) => this.toInstance(UploadModel, pic) as UploadModel),
    );
  }

  /**
   * The post slug
   * @protected
   */
  public get slug(): string | undefined {
    return this.get('slug');
  }
  public set slug(slug: string | undefined) {
    this.set('slug', slug);
  }

  /**
   * The post-title
   * @protected
   */
  public get title(): TranslationColumnValueModel | undefined {
    return this.get('title');
  }
  public set title(title: any | undefined) {
    this.setInstance('title', TranslationColumnValueModel, title);
  }

  /**
   * The post description
   * @protected
   */
  public get description(): TranslationColumnValueModel | undefined {
    return this.get('description');
  }
  public set description(description: any | undefined) {
    this.setInstance('description', TranslationColumnValueModel, description);
  }

  /**
   * The post short description
   * @protected
   */
  public get shortDescription(): TranslationColumnValueModel | undefined {
    return this.get('shortDescription');
  }
  public set shortDescription(shortDescription: any | undefined) {
    this.setInstance('shortDescription', TranslationColumnValueModel, shortDescription);
  }

  public constructor(data?: any) {
    super(data);
  }

  public override fullName(): TranslationColumnValueModel | string {
    return this.title || '';
  }

  public override metaDescription(): TranslationColumnValueModel | string {
    return this.shortDescription || '';
  }

  public override metaImage(): string {
    return this.picture?.defaultUrl || '';
  }

  public override metaImageSize(): MetaImageSizeOptionsType {
    return this.picture?.dimension() || {};
  }

  protected override onClone(): this {
    return new PostModel({
      category: this.category,
      description: this.description?.clone(),
      shortDescription: this.shortDescription?.clone(),
    }) as this;
  }
}
